<button mat-raised-button color="primary" (click)="button()" matTooltip="Show images">
    <mat-icon aria-label="Image">{{ icon }}</mat-icon>
</button>